import { Chip } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import ApartmentIcon from "@mui/icons-material/Apartment";
import LockIcon from "@mui/icons-material/Lock";
import GavelIcon from "@mui/icons-material/Gavel";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SchoolIcon from "@mui/icons-material/School";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { HospitalTypeChipProps } from "../../../../utils/dto/module/scheme.types";

export const HospitalType = [
    { label: "Private", value: "private" },
    { label: "Government", value: "government" },
    { label: "Semi Government", value: "semi_government" },
    { label: "Trust", value: "trust" },
    { label: "Charity", value: "charity" },
    { label: " Public Health Department", value: "phd" },
    { label: "Directorate of Medical Education and Research", value: "dmer" },
    { label: "Government of India", value: "goi" }
];

const HospitalTypeChip: React.FC<HospitalTypeChipProps> = ({ type }) => {
    const typeConfig: Record< HospitalTypeChipProps["type"], { color: string; icon: JSX.Element } > = {
        private: { color: "#F57C00", icon: <LockIcon /> },
        government: { color: "#43A047", icon: <GavelIcon /> },
        semi_government: { color: "#8E24AA", icon: <ApartmentIcon /> },
        trust: { color: "#1E88E5", icon: <BusinessIcon /> },
        charity: { color: "#fa4d4d", icon: <FavoriteIcon /> },
        PHD: { color: "#6A1B9A", icon: <SchoolIcon /> },
        DMER: { color: "#00897B", icon: <LocalHospitalIcon /> },
        GOI: { color: "#3949AB", icon: <AccountBalanceIcon /> },
    };

    const defaultConfig = { color: "#9E9E9E", icon: <HelpOutlineIcon /> };

    return (
        <Chip
            size="small"
            label={type?.replace("_", " ").toUpperCase() || "UNKNOWN"}
            icon={typeConfig[type]?.icon || defaultConfig.icon}
            sx={{
                backgroundColor: typeConfig[type]?.color || defaultConfig.color,
                color: "#fff",
                fontWeight: "bold",
                borderRadius: "8px",
                minWidth: "120px",
                justifyContent: "flex-start",
                "& .MuiChip-icon": { color: "#fff" },
            }}
        />
    );
};

export default HospitalTypeChip;
